import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function PonyvaTisztitas() {
  return (
    <SubPageLayout
      eyebrow="Tisztítás, felújítás"
      title="Új életet adunk a régi ponyvának."
      intro="Évekre meghosszabbítjuk a ponyva élettartamát – gyakran a csere költségének töredékéért."
      heroImage="/assets/gallery/palletways-01.jpg"
      bullets={[
        { title: "Profi mosás", text: "Nagynyomású, ipari tisztítószerek – minden szennyeződés ellen." },
        { title: "Kisebb javítás", text: "Tisztítás közben fellelt apró sérülések azonnali javítása." },
        { title: "Költségmegtakarítás", text: "Az új ponyva árának 20–40%-áért szinte új minőségű ponyva." },
      ]}
      gallery={SITE_IMAGES.repairGallery}
    >
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="bg-gradient-to-br from-[#1E3E62] to-[#0B192C] text-white rounded-lg p-8 md:p-10 relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-60 h-60 rounded-full bg-[#EA580C]/15 blur-3xl" />
            <div className="grid md:grid-cols-3 gap-6 relative">
              {[
                { v: "20–40%", l: "új ár töredéke" },
                { v: "+3–5", l: "év élettartam plusz" },
                { v: "1–3 nap", l: "átfutási idő" },
              ].map((s) => (
                <div key={s.l}>
                  <div className="font-heading font-extrabold text-[#EA580C] text-3xl md:text-4xl">{s.v}</div>
                  <div className="text-sm text-gray-300 mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
